'use strict';

bbw.shared.SearchCtrl = ngtk.controller.Base.extend({

    $inject: ['$scope', '$timeout', '$q', 'modelFactory', '$rootScope', 'rpcClient', 'bbw.RedirectSvc', 'bbw.LocationSvc', 'bbw.ConfigSvc', 'growl', '$attrs'],

    _getTabNames: function() {
        return {simple: 'simple', extended: 'extended'};
    },

    _defaultTab: 'simple',

    _locState: undefined,

    /**
     * @type {ngtk.model.Factory}
     */
    _modelFactory: undefined,

    /**
     * @type {bbw.service.LocationSvc}
     */
    _bbwLocationSvc: undefined,

    /**
     * @type {bbw.model.Lang}
     */
    _langAttrs: undefined,

    /**
     * @type {bbw.model.Lang}
     */
    _langZodiac: undefined,

    /**
     * @type {bbw.model.Geo}
     */
    _geo: undefined,

    /**
     * @type {ngtk.rpcClient.Client}
     */
    _rpcClient: undefined,

    _page: undefined,

    _isInitialized: false,

    _isExtended: false,

    _init: function() {
        this._initScope();
        this._initLangAttrs();
        this._initZodiac();
        this._initGeo();
        this._initRequest();

        this.$scope.findPage = this.findPage.bind(this);

        var repaintSliderOnResize = function() {
            this.$timeout(this.refreshSlider.bind(this));
        }.bind(this);

        window.addEventListener('resize', repaintSliderOnResize);
        this.$scope.$on('$destroy', function() {
            window.removeEventListener('resize', repaintSliderOnResize);
        });

        return this.$q.all([
            this._initLocationAndTabs(),
            this._langAttrs.loadAttrLists('search'),
            this._langZodiac.loadAttrLists('zodiac')
        ])
            .then(this._loadLastSearch.bind(this))
            .then(function() {
                this._configureByGender();
                this._updateInitShowForm();

                return this.find().then(function() {
                    this._isInitialized = true;
                }.bind(this));
            }.bind(this));
    },

    _updateInitShowForm: function() {
        this._setShowForm(this.$attrs.collapse === 'true' ? false : angular.isUndefined(this._page));
    },

    _initScope: function() {
        this.$scope.search = {
            request: {}
        };
    },

    _initLocationAndTabs: function() {
        var $scope = this.$scope;

        $scope.tabs = {};
        $scope.tabNames = this._getTabNames();

        var states = {};
        Object.keys($scope.tabNames).forEach(function(tabName) {
            states[tabName] = tabName;
        });

        this._locState = this._bbwLocationSvc.createLocState({
            scope: this.$scope,
            defaultState: [this._defaultTab],
            states: states,
            onStateChange: function(state) {
                this._isExtended = (state.name === 'extended');
                this.refreshSlider();
                if ($scope.tabs.$select) {
                    $scope.tabs.$select(state.name);
                } else {
                    $scope.defaultSelectedTab = state.name;
                }
                if (angular.isDefined(state.params.page)) {
                    this._page = parseInt(state.params.page);
                    this._onPageChanged();
                } else {
                    if (angular.isDefined(this._page)) {
                        this._page = 0;
                        this._onPageChanged();
                    }
                }
            }.bind(this)
        });

        return this._locState.run().then(function() {
            // $scope.sw = {hash: this._locState.getHash()};
            // $scope.$watch('sw.hash', function(value, oldValue) {
            //     if (value != oldValue) {
            //         this._locState.setHash(value, true);
            //     }
            // }.bind(this));
            var initial = true;
            $scope.onTabSelected = function(name) {
                if (initial) {
                    initial = false;
                } else {
                    this._locState.setState(name, undefined, angular.isDefined(this._page) ? {page: this._page} : undefined);
                }
            }.bind(this);
        }.bind(this));

    },

    _onPageChanged: function() {
        if (this.$scope.ctrlStatus.ready) {
            this.find();
        }
    },

    _initLangAttrs: function() {
        this._langAttrs = this._modelFactory.create(bbw.model.Lang).wireScope(this.$scope, 'lang.attrs');
    },

    _initZodiac: function() {
        this._langZodiac = this._modelFactory.create(bbw.model.Lang).wireScope(this.$scope, 'lang.zodiac');
    },

    _initGeo: function() {
        this._geo = this._modelFactory.create(bbw.model.Geo).setInjectSeparators().wireScope(this.$scope, 'geo');
    },

    _initRequest: function() {
        ngtk.tools.object.replace(this.$scope.search.request, {
            age_min: this._bbwConfigSvc.get('age.min'),
            age_max: this._bbwConfigSvc.get('age.max'),
            weight_min: this._bbwConfigSvc.get('weight.min'),
            weight_max: this._bbwConfigSvc.get('weight.max'),
            height_min: this._bbwConfigSvc.get('height.min'),
            height_max: this._bbwConfigSvc.get('height.max')
        });
    },

    _setPage: function(page) {
        this._locState.setState(undefined, undefined, {page: page || '0'}, false, this._page == page);
    },

    findGo: function() {
        var page = this._page;
        this.findPage(0);
        if (page == 0) {
            this.find();
        }
    },

    findPage: function(page) {
        this._setPage(page);
        this._setShowForm(false);
    },

    _setShowForm: function(value) {
        this.$scope.ctrlStatus.showForm = !!value;
    },

    _applyLast: function() {
        this.$scope.search.request = this._last || {};
        ['age', 'weight', 'height'].forEach(function(attrKey) {
            ['min', 'max'].forEach(function(modKey) {
                var requestKey = attrKey + '_' + modKey;
                if (!this.$scope.search.request[requestKey]) {
                    this.$scope.search.request[requestKey] = bbw.configuration[attrKey][modKey];
                }
            }.bind(this));
        }.bind(this));
    },

    showForm: function(isFormVisible, refreshSlider, updateLocation) {
        if (angular.isUndefined(isFormVisible)) {
            isFormVisible = true;
        }
        this._setShowForm(!!isFormVisible);
        window.scrollTo(0, 0);
        refreshSlider && this.refreshSlider();
        if (updateLocation) {
            if (!isFormVisible) {
                this._setPage(this._page);
            } else {
                if (!this._page) {
                    this._page = undefined;
                    this._locState.setState(undefined, undefined, {}, false, true);
                }
            }
        }
    },

    refreshSlider: function() {
        this.$scope.$broadcast('refreshSlider');
    },

    findRedirect: function() {
        this.find().finally(this._bbwRedirectSvc.redirectTo.bind(this._bbwRedirectSvc, 'search', {type: 'collapse'}));
    },

    find: function(showFormAfterSearch) {
        var params;
        if (this._isExtended) {
            params = angular.copy(this.$scope.search.request);
            params.is_extended = true;
        } else {
            params = this._getMainRequestParams();
            params.is_extended = false;
        }

        if (this.$attrs.new === 'true') {
            params.no_remember = true;
        }

        params.page = parseInt(this._page);
        if (isNaN(params.page)) {
            params.page = 0;
        }

        this.$scope.ctrlStatus.searching = true;
        return this._rpcClient.post('search/find', params).execute().then(function(response) {
            var showForm;
            if (angular.isDefined(response.count)) {
                if (!angular.isArray(response.items)) {
                    response.items = [];
                }
                if (response.items.length) {
                    if (angular.isDefined(showFormAfterSearch)) {
                        showForm = !!showFormAfterSearch;
                    }
                } else {
                    showForm = true;
                }
                if (angular.isDefined(showForm)) {
                    this._setShowForm(showForm);
                }
                this.$scope.search.response = response;
                window.scrollTo(0, 0);
                this.$timeout(this.refreshSlider.bind(this), 10);
            } else if (!response.success || !forRedirect) {
                return this.$q.reject('internal_error');
            }
        }.bind(this)).catch(function(response) {
            this._growl.error(response.error, response);
        }.bind(this)).finally(function() {
            delete this.$scope.ctrlStatus.searching;
        }.bind(this));
    },

    _run: function() {
        this.refreshSlider();
    },

    _loadLastSearch: function() {
        if (this.$attrs.new === 'true') {
            this._last = {
                is_new: true, has_photo: true, no_remember: true
            };
            this._applyLast();
            return this._loadGeo();
        } else {
            return this._rpcClient.get('search/get-last-request').execute().then(function(response) {
                this._last = response.request;
                this.$scope.locations = response.default_locations;
                this._applyLast();
                return this._loadGeo();
            }.bind(this));
        }
    },

    _configureByGender: function() {
        delete this.$scope.search.request.a_want_relations; // v1 profile fix

        if (bbw.userGender) {
            switch (bbw.userGender) {
                case 'm':
                    this.$scope.search.request.a_want_sex = 'm';
                    this.$scope.search.request.a_sex = 'f';
                    delete this.$scope.search.request.a_want_relations_f;
                    break;
                case 'f':
                    this.$scope.search.request.a_want_sex = 'f';
                    if (['m', 'f'].indexOf(this.$scope.search.request.a_sex) == -1) {
                        this.$scope.search.request.a_sex = 'm';
                        delete this.$scope.search.request.a_want_relations_m;
                    }
                    break;
            }
        }
    },

    _loadGeo: function() {
        return this._geo.setSelected(this.$scope.search.request).loadAll();
    },

    _getMainParams: function() {
        var mainParams = [
            'a_sex',
            'a_want_sex',
            'age_min',
            'age_max',
            'location',
            'has_photo',
            'is_online',
            'is_new',
            'no_remember',
            'flush_cache'
        ];
        if (bbw.userGender) {
            switch (bbw.userGender) {
                case 'm':
                    mainParams.push('a_want_relations_m');
                    break;
                case 'f':
                    mainParams.push('a_want_relations_f');
                    break;
            }
        }
        return mainParams;
    },

    _getMainRequestParams: function() {
        var request = this.$scope.search.request;
        return this._getMainParams().reduce(
            function(carry, key) {
                if (angular.isDefined(request[key])) {
                    carry[key] = request[key];
                }
                return carry;
            }, {merge: true}
        );
    }

});
